import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import * as React from 'react';
import { useValueRef } from '@cian/react-utils';
import { useDropdownController } from '../../../internal/hooks/controllers';
import { useFocusGroupOptionController } from '../useFocusGroupOptionController';
export function useGroupedSelectDesktopController(props) {
  var _useDropdownControlle = useDropdownController(props),
    open = _useDropdownControlle.open,
    dropdownActions = _useDropdownControlle.actions;
  var _useFocusGroupOptionC = useFocusGroupOptionController({
      groups: props.groups
    }),
    focusedIndex = _useFocusGroupOptionC.focusedIndex,
    focusedOptionActions = _useFocusGroupOptionC.actions;
  var stateRef = useValueRef({
    props: props,
    open: open,
    focusedIndex: focusedIndex
  });
  React.useEffect(function () {
    var _stateRef$current$pro = stateRef.current.props,
      groups = _stateRef$current$pro.groups,
      value = _stateRef$current$pro.value;
    if (!open) {
      var selectedOptionIndex = 0;
      var selectedGroupIndex = groups.findIndex(function (group) {
        var optionIndex = group.options.findIndex(function (option) {
          return option.value === value;
        });
        if (optionIndex === -1) {
          return false;
        }
        selectedOptionIndex = optionIndex;
        return true;
      });
      focusedOptionActions.setFocusedIndex({
        group: Math.max(selectedGroupIndex, 0),
        option: selectedOptionIndex
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  var selectOption = function selectOption(index) {
    var props = stateRef.current.props;
    var group = props.groups[index.group];
    if (!group) {
      return;
    }
    var option = group.options[index.option];
    var optionValue = option.value;
    var prevValue = props.value;
    if (optionValue !== prevValue) {
      props.onChange(optionValue);
    }
  };
  var selectFocusedOption = function selectFocusedOption() {
    return selectOption(stateRef.current.focusedIndex);
  };
  var actions = _objectSpread(_objectSpread(_objectSpread({}, dropdownActions), focusedOptionActions), {}, {
    selectOption: selectOption,
    selectFocusedOption: selectFocusedOption
  });
  return {
    open: open,
    focusedIndex: focusedIndex,
    actions: actions
  };
}